import { useState } from "react";
import { Link } from "react-router-dom";
import { Shovel } from "lucide-react";
import { PHASE_MAP, phaseBadge } from "@/lib/phases";
import { SitePlaceholder } from "@/components/SitePlaceholder";

// Minimal card: photo + name only (with a small phase badge + deep-dive dot).
export const PyramidCompactCard = ({ p, index = 0 }) => {
  const ph = PHASE_MAP[p.phase] || PHASE_MAP.pyramids;
  const src = p.gallery?.[0];
  const [broken, setBroken] = useState(false);
  const showImg = src && !broken;

  return (
    <Link
      to={`/pyramid/${p.slug}`}
      data-testid={`pyramid-compact-${p.slug}`}
      className="group relative flex flex-col overflow-hidden bg-card border border-border hover:border-accent/50 transition-colors duration-300 hover:-translate-y-0.5 shadow-sm hover:shadow-lg fade-up"
      style={{ animationDelay: `${Math.min(index, 16) * 30}ms` }}
    >
      <div className="relative aspect-square overflow-hidden bg-secondary">
        {showImg ? (
          <img
            src={src}
            alt={p.name}
            loading="lazy"
            onError={() => setBroken(true)}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <SitePlaceholder phase={p.phase} className="h-full w-full" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
        <span
          className="absolute top-2 right-2 text-white font-mono text-[8px] uppercase tracking-widest px-1.5 py-0.5 backdrop-blur-sm"
          style={{ background: `${ph.color}E6` }}
        >
          {phaseBadge(p.phase)}
        </span>
        {!!p.research && (
          <span
            data-testid={`compact-deep-dive-${p.slug}`}
            title="Deep dive available"
            className="absolute top-2 left-2 flex items-center justify-center h-5 w-5 bg-accent text-accent-foreground shadow"
          >
            <Shovel className="h-2.5 w-2.5" />
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 p-2.5">
          <h3 className="font-serif text-sm font-semibold leading-tight text-white line-clamp-2 group-hover:text-accent transition-colors">
            {p.name}
          </h3>
          <p className="mt-0.5 font-mono text-[9px] uppercase tracking-wider text-white/70">{p.country}</p>
        </div>
      </div>
    </Link>
  );
};
